import { ADMIN_ROOT, SPACE_ANALYTICS, SPACE_MANAGEMENT } from "hybridspace-common/lib/constants";
import { useIsSpaceManagementAdminTabEnabled } from "hybridspace-common/lib/utils/adminUtils";

export function useDefaultAdminScreenId() {
    const { isManagementEnabled } = useIsSpaceManagementAdminTabEnabled();
    
    // set default admin tab based on whether management portal is enabled
    const defaultAdminTab = isManagementEnabled ? SPACE_MANAGEMENT : SPACE_ANALYTICS;
    
    return `/${ADMIN_ROOT}/${defaultAdminTab}`;
}
